// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"d2b0a43f","917":"8637e4ce"}[chunkId] + ".chunk.js";
};